<div flexLayout="row">
    <div fxFlex="80" fxLayout="column" fxLayoutAlign="center start">
        <div class="example-pizza-party" *ngFor="let item of data">
            {{item.title|uppercase}} : {{item.value[0]|titlecase}}
        </div>
    </div>
    <div fxFlex="20" fxLayoutAlign="end center">
        <button mat-raised-button style="background-color: transparent;" (click)="ok()">Ok</button>
    </div>
</div>